import React from "react";
import { Box, Button, Modal, Typography, TextField } from "@mui/material";
import axios from "axios";
import { useUser, useSetUser } from "../../../globals/UserContext";
import { joinClassAction } from "../../../actions/joinClass";
import { useSetQuestion } from "../../../globals/QuestionContext";
import { useSetAssignment } from "../../../globals/AssignmentContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function CreateClassModal(props) {
  const user = useUser();
  const setUser = useSetUser();
  let name = "";
  const setQuestion = useSetQuestion();
  const setAssignment = useSetAssignment();

  const handleSubmit = () => {
    axios
      .post(`${REACT_APP_DEBUGGER_SERVER_URL}/classes`, {
        name: name,
        adminID: user._id,
        teacherName: user.name,
      })
      .then((response) => {
        joinClassAction(
          user._id,
          response.data._id,
          setUser,
          setAssignment,
          setQuestion
        );
      })
      .catch((error) => {
        console.log(error);
      });
    props.handleClose();
  };

  const handleChange = (event) => {
    name = event.target.value;
  };

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Create Class
        </Typography>
        <TextField
          id="standard-basic"
          label="Class Name"
          onChange={handleChange}
          variant="standard"
        />
        <Button
          sx={{ marginTop: "15px", marginLeft: "5px" }}
          onClick={handleSubmit}
          variant="outlined"
          color="primary"
          size="small"
        >
          Create
        </Button>
      </Box>
    </Modal>
  );
}
